module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Delete Form","introduction":["Are you sure you want to delete the Form {name} and all of its Submissions?","This action cannot be undone."]}}')
  delete Component.options._Ctor
}
